import React, { Component } from 'react';
import { Typography, Paper, List, ListItem, ListItemIcon, ListItemText, TablePagination, } from '@material-ui/core';
import { Done, } from '@material-ui/icons';
import { version } from './VersionDataOld';

export const latestVersion = 'V0.6.9.0'; // Live
// export const latestVersion = 'V0.6.2.5'; // Dev
// Dev User UPDATE TblUsers SET CurrentSystemVersion = '' WHERE UserId = 'HBS';
// Live User UPDATE TblUsers SET CurrentSystemVersion = '' WHERE UserId = 'AUSS_ADMIN';

class Version extends Component {
    state = {
        // { desc: 'Booking Changes Status: Management Approved Added' },
        // { desc: 'Booking Changes: Charges Approved to BASE SI' },
        // { desc: '' },
        updates: [
            {
                version: 'V0.6.9.0',
                date: '02 Oct 2026',
                updateList: [
                    { desc: 'WB List - Search additional fields' },
                ],
            },
            {
                version: 'V0.6.8.9',
                date: '13 Aug 2026',
                updateList: [
                    { desc: 'WB List - Waybill with Truckers Waybill' },
                ],
            },
            {
                version: 'V0.6.8.8',
                date: '05 Aug 2026',
                updateList: [
                    { desc: 'SQ Clone Fixes' },
                ],
            },
            {
                version: 'V0.6.8.7',
                date: '05 Aug 2026',
                updateList: [
                    { desc: 'SQ Approved View - List No Expired' },
                ],
            },
            {
                version: 'V0.6.8.6',
                date: '08 Jun 2026',
                updateList: [
                    { desc: 'Waybill Printout Rollback Setup' },
                ],
            },
            {
                version: 'V0.6.8.5',
                date: '01 Jun 2026',
                updateList: [
                    { desc: 'Waybill Printout - Separate Shipper/Consignee Name and Preferred Name.' },
                ],
            },
            {
                version: 'V0.6.8.4',
                date: '29 Apr 2026',
                updateList: [
                    { desc: 'SQ Printout: Updated terms of payment from invoice date to billing date.' },
                ],
            },
            {
                version: 'V0.6.8.3',
                date: '21 Apr 2026',
                updateList: [
                    { desc: 'Booking View Expiration Access Added' },
                ],
            },
            {
                version: 'V0.6.8.2',
                date: '18 Apr 2026',
                updateList: [
                    { desc: 'Master Data Customer Download List' },
                ],
            },
            {
                version: 'V0.6.8.1',
                date: '10 Mar 2026',
                updateList: [
                    { desc: 'Master Data Container Van Update Fixes' },
                    { desc: 'SQ Deactivation Module Added'},
                    { desc: 'SQ Deactivation Log Module Added'}
                ],
            },
            {
                version: 'V0.6.8.0',
                date: '05 Mar 2026',
                updateList: [
                    { desc: 'Master Data Container Van Update Fixes' },
                ],
            },
            {
                version: 'V0.6.7.9',
                date: '23 Feb 2026',
                updateList: [
                    { desc: 'Master Data Container Van Update' },
                ],
            },
            {
                version: 'V0.6.7.8',
                date: '10 Feb 2026',
                updateList: [
                    { desc: 'Master Data Container Van Update' },
                    { desc: 'Voyage Schedule Arrange' },
                ],
            },
            {
                version: 'V0.6.7.7',
                date: '17 Dec 2025',
                updateList: [
                    { desc: 'Master Data Charges View DC fixes' },
                ],
            },
            {
                version: 'V0.6.7.6',
                date: '29 Oct 2025',
                updateList: [
                    { desc: 'Master Data Charge Update fixes' },
                ],
            },
            {
                version: 'V0.6.7.5',
                date: '25 Oct 2025',
                updateList: [
                    { desc: 'SQ Printout Peso Sign (P) fixes' },
                ],
            },
            {
                version: 'V0.6.7.4',
                date: '17 Oct 2025',
                updateList: [
                    { desc: 'Customer Request Creation: File Request - Proof of Account Revise Require' },
                ],
            },
            {
                version: 'V0.6.7.3',
                date: '16 Oct 2025',
                updateList: [
                    { desc: 'Customer Request Creation: File Request - Proof of Account Changes and Require' },
                ],
            },
            {
                version: 'V0.6.7.2',
                date: '2 Sep 2025',
                updateList: [
                    { desc: 'Booking Changes Read/View - Insurance Premium Fixes' },
                ],
            },
            {
                version: 'V0.6.7.1',
                date: '1 Sep 2025',
                updateList: [
                    { desc: 'Booking Changes - Insurance Premium Fixes' },
                ],
            },
            {
                version: 'V0.6.7.0',
                date: '9 Apr 2025',
                updateList: [
                    { desc: 'SQ Printout Approved By Change Signatory' },
                ],
            },
            {
                version: 'V0.6.6.9',
                date: '28 Jan 2025',
                updateList: [
                    { desc: 'Waiver List: Requested Field/Amount Added' },
                ],
            },
            {
                version: 'V0.6.6.8',
                date: '25 Jan 2025',
                updateList: [
                    { desc: 'SQ Printout Specific Sorting' },
                ],
            },
            {
                version: 'V0.6.6.7',
                date: '05 Nov 2024',
                updateList: [
                    { desc: 'Tally Sheet Print-Out Fixes' },
                ],
            },
            {
                version: 'V0.6.6.6',
                date: '21 Oct 2024',
                updateList: [
                    { desc: 'Collection List - Balance Amount Fixes' },
                ],
            },
            {
                version: 'V0.6.6.5',
                date: '10 Oct 2024',
                updateList: [
                    { desc: 'Collection - Remove Insurance Premium Header Computation' },
                ],
            },
            {
                version: 'V0.6.6.4',
                date: '25 Sep 2024',
                updateList: [
                    { desc: 'Booking Change Cancelled List Fixes' },
                    { desc: 'Waiver Form UI Fixes' },
                ],
            },
            {
                version: 'V0.6.6.3',
                date: '02 Jul 2024',
                updateList: [
                    { desc: 'SQ Document Charge Request and Standard Same Rates Checking Fixes' },
                ],
            },
            {
                version: 'V0.6.6.2',
                date: '11 Jun 2024',
                updateList: [
                    { desc: 'SQ TC Request and Standard Same Value Checking' },
                    { desc: 'SQ Document Charge Request and Standard Same Rates Checking' },
                ],
            },
            {
                version: 'V0.6.6.1',
                date: '03 May 2024',
                updateList: [
                    { desc: 'Booking Remove Tandem Alert' },
                ],
            },
            {
                version: 'V0.6.6.0',
                date: '02 May 2024',
                updateList: [
                    { desc: 'SQ Printout SOC: 2000 to 6000' },
                ],
            },
        ],
        page: 0,
        rowsPerPage: 15,
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    render() {
        const { updates, page, rowsPerPage } = this.state;
        var Data = updates.concat(version);
        return (
            <div style={{ marginTop: 48 }}>
                <div style={{ width: window.screen.width > 768 ? 868 : '100%', padding: '4px 16px 0 16px', margin: 'auto' }}>
                    <div style={{ display: window.screen.width > 768 ? 'flex': ''}}>
                        <Typography style={window.screen.width > 768 ? { flexGrow: 1, marginTop: 12 } : {}} variant="h6" gutterBottom>What's new</Typography>
                        <TablePagination rowsPerPageOptions={[15, 30, 60]} component="div" count={Data.length} rowsPerPage={rowsPerPage} page={page} backIconButtonProps={{ 'aria-label': 'Previous Page', }} nextIconButtonProps={{ 'aria-label': 'Next Page', }} onChangePage={this.handleChangePage} onChangeRowsPerPage={this.handleChangeRowsPerPage} />
                    </div>
                </div>
                <div style={{ maxHeight: window.screen.width > 768 ? 'calc(100vh - 108px)' : 'calc(100vh - 140px)', overflowY: 'auto' }}>
                    <div style={{ width: window.screen.width > 768 ? 868 : '100%', padding: '12px 16px 16px', margin: 'auto' }}>
                        {Data && Data.length ? (
                            Data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((update, i) => (
                                <Paper key={i} style={{ marginTop: i === 0 ? 0 : 10, padding: 8 }}>
                                    <List dense>
                                        <ListItem>
                                            <ListItemText primary={update.version} secondary={update.date} />
                                        </ListItem>
                                        {update.updateList.map((list, i) => (
                                            <ListItem key={i}>
                                                <ListItemIcon><Done fontSize='small' color='primary' /></ListItemIcon>
                                                <ListItemText primary={list.desc} secondary={null} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Paper>
                            ))
                        ) : null}
                    </div>
                </div>
            </div>
        )
    }
}
export default Version